import { getCatalogFilterStoreByProductType } from '../stores/catalog_filter_store/factory';
import { CatalogSortingStore } from '../stores/catalog_sorting_store';
import { showAction } from '../actions/ui_lock_actions';
import { Filters } from '../constants/filter/filters';
import { types } from '../../_constants/product/types';
import CatalogConfiguratorStore from '../stores/catalog_configurator_store';
import VehicleConfiguratorStore from '../stores/vehicle_configurator_store';
import RegoLookupStore from '../stores/rego_lookup_store';
import { forOwn } from '../../../lib/utilities';
import { setPostcodeV2 } from './requests/set_postcode_v2';
import getTranslatedText from './get_translated_text';
import CONFIGURATOR_TYPES from '../constants/configurator_types';

function appendOptionForForm($form, filterValue, filterName) {
  $form.append($(`<input type="hidden" name="${filterName}" value="${filterValue}" />`));
}

/**
 * @param {string} productType
 */
async function applyFilters(productType, configuratorType) {
  const regoLookupStore = RegoLookupStore.getState();
  const vehicleConfiguratorStore = VehicleConfiguratorStore.getState();
  const catalogConfiguratorStore = CatalogConfiguratorStore.getState();
  const { region, ...filters } = getCatalogFilterStoreByProductType(productType).getState();
  const currentSorting = CatalogSortingStore.getState().currentSorting;
  let values = {
    ...filters,
    s: currentSorting.sorting,
    d: currentSorting.direction,
  };

  if (configuratorType === CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR) {
    values = {
      ...values,

      [Filters.VEHICLE_DETAILS]: vehicleConfiguratorStore.values[Filters.VEHICLE_DETAILS],
      [Filters.VEHICLE_DETAILS_LABEL]: vehicleConfiguratorStore.values[Filters.VEHICLE_DETAILS_LABEL],
      [Filters.VEHICLE_ENGINE]: vehicleConfiguratorStore.values[Filters.VEHICLE_ENGINE],
      [Filters.VEHICLE_MAKE]: vehicleConfiguratorStore.values[Filters.VEHICLE_MAKE],
      [Filters.POSTCODE]: vehicleConfiguratorStore.values[Filters.POSTCODE],
      [Filters.VEHICLE_SERIES_CHASSIS]: vehicleConfiguratorStore.values[Filters.VEHICLE_SERIES_CHASSIS],
      [Filters.TYRE_OPTIONS]: vehicleConfiguratorStore.values[Filters.TYRE_OPTIONS],
      [Filters.VEHICLE_TYRES]: vehicleConfiguratorStore.values[Filters.VEHICLE_TYRES],
      [Filters.VEHICLE_ID]: vehicleConfiguratorStore.values[Filters.VEHICLE_ID],
      [Filters.VEHICLE_NOT_PROVIDED_COMMENT]: vehicleConfiguratorStore.values[Filters.VEHICLE_NOT_PROVIDED_COMMENT],
      [Filters.VEHICLE_MODEL]: vehicleConfiguratorStore.values[Filters.VEHICLE_MODEL],
      [Filters.VEHICLE_YEAR]: vehicleConfiguratorStore.values[Filters.VEHICLE_YEAR],
    };
  } else if (configuratorType === CONFIGURATOR_TYPES.REGO_LOOKUP) {
    values = {
      ...values,

      [Filters.VEHICLE_CHASSIS]: regoLookupStore.values[Filters.VEHICLE_CHASSIS],
      [Filters.VEHICLE_COUNTRY_OF_ORIGIN]: regoLookupStore.values[Filters.VEHICLE_COUNTRY_OF_ORIGIN],
      [Filters.VEHICLE_DETAILS]: regoLookupStore.values[Filters.VEHICLE_DETAILS],
      [Filters.VEHICLE_ENGINE]: regoLookupStore.values[Filters.VEHICLE_ENGINE],
      [Filters.VEHICLE_ENGINE_DETAILS]: regoLookupStore.values[Filters.VEHICLE_ENGINE_DETAILS],
      [Filters.VEHICLE_MAKE]: regoLookupStore.values[Filters.VEHICLE_MAKE],
      [Filters.POSTCODE]: regoLookupStore.values[Filters.POSTCODE],
      [Filters.REGISTRATION]: regoLookupStore.values[Filters.REGISTRATION],
      [Filters.VEHICLE_SERIES]: regoLookupStore.values[Filters.VEHICLE_SERIES],
      [Filters.VEHICLE_STATE]: regoLookupStore.values[Filters.VEHICLE_STATE],
      [Filters.TYRE_OPTIONS]: regoLookupStore.values[Filters.TYRE_OPTIONS],
      [Filters.VEHICLE_TYRES]: regoLookupStore.values[Filters.VEHICLE_TYRES],
      [Filters.VEHICLE_ID]: regoLookupStore.values[Filters.VEHICLE_ID],
      [Filters.VEHICLE_NOT_PROVIDED_COMMENT]: regoLookupStore.values[Filters.VEHICLE_NOT_PROVIDED_COMMENT],
      [Filters.VEHICLE_MODEL]: regoLookupStore.values[Filters.VEHICLE_MODEL],
      [Filters.VEHICLE_VIN]: regoLookupStore.values[Filters.VEHICLE_VIN],
      [Filters.VEHICLE_YEAR_RANGE_FROM]: regoLookupStore.values[Filters.VEHICLE_YEAR_RANGE_FROM],
      [Filters.VEHICLE_YEAR_RANGE_TO]: regoLookupStore.values[Filters.VEHICLE_YEAR_RANGE_TO],
    };
  }

  if (regoLookupStore.fromTyreSize) {
    values = {
      ...values,
      ...catalogConfiguratorStore.values,
    };
  } else if (vehicleConfiguratorStore.fromTyreSize) {
    values = {
      ...values,
      ...catalogConfiguratorStore.values,
    };
  }

  if (TYROOLA.initialFluxStates.catalogPageVersion) {
    values.catalog_page_version = TYROOLA.initialFluxStates.catalogPageVersion;
  }

  const $form = $(`
        <form
          action="${TYROOLA.globals.urlPrefix}/catalog/"
          method="get"
          style="display: none;"
        />
    `);

  forOwn(values, (filterValue, filterName) => {
    if (filterName === Filters.POSTCODE) {
      appendOptionForForm($form, filterValue, 'shippingPostcode');
    } else if (filterName !== Filters.PRICE_MIN && filterName !== Filters.PRICE_MAX) {
      appendOptionForForm($form, filterValue, filterName);
    }
  });

  let currentConfiguratorType = productType;
  if (
    false === vehicleConfiguratorStore.visible &&
    false === regoLookupStore.visible &&
    [types.TYRE_CAR, types.TYRE_MOTO].indexOf(productType) !== -1
  ) {
    currentConfiguratorType = catalogConfiguratorStore.configuratorType;
  }
  appendOptionForForm($form, currentConfiguratorType, 'product_type');

  let price = '0-0';
  if (values[Filters.PRICE_MIN]) {
    price = price.replace(/0-/, values[Filters.PRICE_MIN] + '-');
  }
  if (values[Filters.PRICE_MAX]) {
    price = price.replace(/-0/, '-' + values[Filters.PRICE_MAX]);
  }
  appendOptionForForm($form, price, 'price');

  try {
    await setPostcodeV2(values['postcode']);
  } catch (error) {
    console.log('error', error);
  } finally {
    $(document.body).append($form);
    window.uiLockText = getTranslatedText('catalog-filter-ui-lock-text');
    showAction();
    window.uiLockText = '';
    $form.submit();
  }
}
export { applyFilters };
